<template>
  <div class="foming">
    <div class="container">
      <div class="row">
        <div class="col s12 m3 l3"></div>
        <div class="col s12 m6 l6">
          <div class="formarea">
            <div class="title">Admin</div>
            <form class="col s12" @submit.prevent="login">
              <div class="row">
                <div class="form__group field">
                  <input
                    type="email"
                    class="form__field"
                    placeholder="Name"
                    name="name"
                    id="name"
                    required
                    v-model="email"
                  />
                  <label for="name" class="form__label">Email</label>
                </div>
                <div class="form__group field">
                  <input
                    type="password"
                    class="form__field"
                    placeholder="Email"
                    id="Email"
                    required
                    v-model="password"
                  />
                  <label for="Email" class="form__label">Password</label>
                </div>

                <input type="submit" class="btn form" value="Login" name="" />
              </div>
            </form>
          </div>
        </div>
        <div class="col s12 m3 l3"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from "@vue/reactivity";
import { useStore } from "vuex";
export default {
  setup() {
    const store = useStore();
    const email = ref("");
    const password = ref("");
    const login = () => {
      store.dispatch("Login", { email: email.value, password: password.value });
    };

    return {
      login,
      email,
      password,
    };
  },
};
</script>

<style lang="scss" scoped>
.foming {
  min-height: 100vh;
}
.title {
  text-align: center;
  text-transform: capitalize;
  font-size: 22px;
  font-weight: 600;
}
.formarea {
  margin-top: 30vh;
}
.form__group {
  position: relative;
  padding: 12px 0 0;
  margin-top: 4px;
  width: 100%;
}

.form__field {
  font-family: inherit;
  width: 100%;
  border: 0;
  border-bottom: 2px solid black !important;
  outline: 0;
  font-size: 14px;
  color: black;
  padding: 7px 0;
  background: transparent;
  transition: border-color 0.2s;

  &::placeholder {
    color: transparent;
  }

  &:placeholder-shown ~ .form__label {
    font-size: 14px;
    cursor: text;
    top: 20px;
  }
}
.form {
  background-color: #765cd1;
  width: 100%;
  margin-top: 20px;
}

.form__label {
  position: absolute;
  top: 0;
  display: block;
  transition: 0.2s;
  font-size: 1rem;
  color: black !important;
}

.form__field:focus {
  ~ .form__label {
    position: absolute;
    top: 0;
    display: block;
    transition: 0.2s;
    font-size: 1rem;
    color: #765cd1 !important;
    font-weight: 700;
  }
  padding-bottom: 6px;
  font-weight: 700;
  border-width: 3px;
  border-image: linear-gradient(to right, #765cd1, #765cd1);
  border-image-slice: 1;
}
/* reset input */
.form__field {
  &:required,
  &:invalid {
    box-shadow: none;
  }
}
</style>
